<template>
  <div>
    <CRow>
      <CCol col="12">
        <CCard>
          <form id="createCategory" @submit="createCategory" >
          <CCardHeader>
            <CCol col="6" style="font-size: 25px;">إضافة قسم جديد</CCol>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="6">
                <CInput label=" English Name"
                  id="name"
                  v-model="category.name"
                  class="required"
                  placeholder=" أدخل إسم القسم بالانجليزية"
                  :invalidFeedback="errors.name"
                  required
                />
              </CCol>
              <CCol sm="6">
                <CInput label="الإسم"
                    id="name_ar"
                  v-model="category.name_ar"
                  class="required"
                  placeholder="أدخل إسم القسم بالعربي"
                  :invalidFeedback="errors.name_ar"
                  required
                />
              </CCol>
            </CRow>
            <CRow>
               <CCol col="6">
                <div class='form-group'>
                  <label for='image' >
                    إضافة أيقونة للقسم الرئيسي
                    <span class='star'>*</span>
                  </label>
                  <input type="file" class="form-control"
                    id="image"
                    v-on:change="onFileChange"
                  >
                  </div>
               </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <CTextarea
                  label='الوصف (اختياري)'
                  placeholder='المحتوى  بالإنجليزية'
                  horizontal
                  rows='4'
                  v-model='category.description'
                  :invalidFeedback="errors.description"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <CTextarea
                  label='الوصف (اختياري)'
                  placeholder='المحتوى بالعربي'
                  horizontal
                  rows='4'
                  v-model='category.description_ar'
                  :invalidFeedback="errors.description_ar"
                />
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter>
            <CButton @click="validation()" type="submit" size="sm" color="primary" ><CIcon name="cil-check-circle"/> حفظ</CButton>
              &emsp;
            <CButton type="reset" size="sm" color="danger"><CIcon name="cil-ban"/> مسح </CButton>
          </CCardFooter>
          </form>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import swal from 'sweetalert'
import $ from 'jquery'
export default {
  name: 'CreateCategory',
  data: function () {
    return {
      category: {},
      errors: [],
      image: ''
    }
  },
  methods: {
    onFileChange (e) {
      const _URL = window.URL || window.webkitURL
      this.image = e.target.files[0]
      let file = ''
      if ((file = e.target.files[0])) {
        const img = new Image()
        img.src = _URL.createObjectURL(file)
      }
    },
    async createCategory (e) {
      e.preventDefault()
      const formData = new FormData()
      if (/^\d+$/.test(this.category.name)) {
        $('#name').addClass('redborder')
        swal('اسم القسم يجب ان يحتوي على حروف')
        return 0
      }
      if (/^\d+$/.test(this.category.name_ar)) {
        swal('اسم القسم يجب ان يحتوي على حروف')
        $('#name_ar').addClass('redborder')
        return 0
      }
      formData.append('name', this.category.name)
      formData.append('name_ar', this.category.name_ar)
      formData.append('icon', this.image)
      if (this.category.description) {
        formData.append('description', this.category.description)
      }
      if (this.category.description_ar) {
        formData.append('description_ar', this.category.description_ar)
      }
      this.errors = await this.postRequest(formData, this.$hostUrl + 'categories', '/categories')
    },
    validation () {
      const Allinput = document.querySelectorAll('form input')
      Allinput.forEach((input) => {
        // eslint-disable-next-line valid-typeof
        input.oninput = function () {
          input.classList.remove('redborder')
        }
        if (input.value === '' && input.type === 'text') {
          input.classList.add('redborder')
          swal(' لا يمكن ترك الحقل فارغا')
          return 0
        }
      })
    }
  }
}

</script>
<style >
.redborder{
  border-color:red !important
}
</style>
